import { IconStore } from '../../../IconStore';

function AnnualDividendCard(props) {
  const formatter = Intl.NumberFormat();
  const textStyle = {
    marginBottom: 0
  };
  const subTextStyle = {
    fontSize: 14,
    verticalAlign: 'top'
  };

  const amount = props.amount;
  const percentOfPortfolio = props.percentOfPortfolio;
  const displayAmount = typeof amount === 'number' ? `$${formatter.format(Math.round(amount))}` : '—';
  const displayPercent = typeof percentOfPortfolio === 'number'
    ? `${percentOfPortfolio.toFixed(2)}% of portfolio`
    : null;

  return (
    <div className="card border-light shadow-sm card-metric">
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center">
          <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
            <div className="icon icon-shape icon-md icon-shape-blue rounded mr-4">
              <span className={'fas ' + IconStore.dollar}></span>
            </div>
            <div className="d-sm-none">
              <h2 className="h5" style={textStyle}>Annual Dividend</h2>
              <h3 className="mb-1">{displayAmount}</h3>
              {displayPercent && (
                <span className="text-muted" style={subTextStyle}>{displayPercent}</span>
              )}
            </div>
          </div>
          <div className="col-12 col-xl-7 px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h5" style={textStyle}>Annual Dividend</h2>
              <h3 className="mb-1">{displayAmount}</h3>
              {displayPercent && (
                <span className="text-muted" style={subTextStyle}>{displayPercent}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnnualDividendCard;
